import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { CustomElement } from '../../classes';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputComponent } from '../input/input.component';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ButtonComponent),
    multi: true
};

@Component({
    selector: 'chassis-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, InputComponent]
})
export class ButtonComponent extends CustomElement implements OnInit {

    @Input() autofocus: boolean;

    @Input() name: string = null;

    @Input() type = 'button';

    @Input() value = 'Submit';

    @Input() loader = false;

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/components/button/button.component.ts